import { render, staticRenderFns } from "./joinGroupOrder.vue?vue&type=template&id=73b7718c&"
import script from "./joinGroupOrder.vue?vue&type=script&lang=js&"
export * from "./joinGroupOrder.vue?vue&type=script&lang=js&"
import style0 from "./joinGroupOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports